import {defineStore} from 'pinia';
import Cookies from "js-cookie";

export const MainStore = defineStore('main', {
    state: () => ({
        timelineVisible: false,
    }),
    getters: {
        isTimelineVisible: (state) => state.timelineVisible,
    },
    actions: {
        setTimelineVisible(value){
            this.timelineVisible = value;
        },
        toggleTimeline() {
            this.timelineVisible = !this.timelineVisible;
            Cookies.set('hidden', Number(this.timelineVisible), {sameSite: 'strict', path: '/'});
        }
    },
})
